import { useTranslation } from "@redotech/redo-i18n";

import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { ReturnWarning } from "@redotech/redo-return-core-common/return";

export function WarningsCard({ warnings }: { warnings: ReturnWarning[] }) {
  const { t } = useTranslation();
  return (
    <Flex flexDirection="column">
      <Text>{t("There were some problems with your return.")}</Text>
      <Text>{t("Here are the issues we are working to resolve:")}</Text>
      {warnings.map((warning: ReturnWarning, i) => {
        return (
          <Flex flexDirection="column" key={i}>
            <Text> {warning.customerMessage}</Text>
          </Flex>
        );
      })}
    </Flex>
  );
}
